<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ title }}</span>
    <v-layout>
      <v-flex xs12>
        <v-card-title> Product Details </v-card-title>
        <v-list three-line>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Product Code*</v-list-item-title>
              <v-list-item-subtitle
                ><v-text-field v-model="editProduct.productCode" outlined dense
              /></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Manufacturer*</v-list-item-title>
              <v-list-item-subtitle
                ><v-text-field v-model="editProduct.manufacturer" outlined dense
              /></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Category*</v-list-item-title>
              <v-list-item-subtitle
                ><v-combobox
                  v-model="editProduct.category"
                  :items.sync="categories"
                  @change="editProduct.subcategory = null"
                  hide-selected
                  small-chips
                  solo
                  dense
                  item-value="_id"
                  full-width
                  :allow-overflow="false"
                  flat
                  outlined
                >
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <div>{{ item.name }}</div>
                  </template>
                  <template v-slot:item="{ index, item }">
                    <v-layout>
                      <v-flex xs12>{{ item.name }}</v-flex>
                    </v-layout>
                  </template>
                </v-combobox></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Subcategory</v-list-item-title>
              <v-list-item-subtitle>
                <v-combobox
                  v-model="editProduct.subcategory"
                  :items="editProduct.category.subcategories"
                  hide-selected
                  small-chips
                  solo
                  dense
                  item-text="name"
                  item-value="_id"
                  full-width
                  :allow-overflow="false"
                  flat
                  outlined
                >
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <div>{{ item.name }}</div>
                  </template>
                  <template v-slot:item="{ index, item }">
                    <v-layout>
                      <v-flex xs12>{{ item.name }}</v-flex>
                    </v-layout>
                  </template>
                </v-combobox></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Description</v-list-item-title>
              <v-list-item-subtitle
                ><v-text-field
                  v-model="editProduct.description[0].value"
                  outlined
                  label=""
                  dense
              /></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> Cost* </v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field
                  v-model="editProduct.invoicePrice"
                  type="number"
                  outlined
                  label=""
                  dense
                />
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-for="(field, index) in category.fieldSettings"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>{{ field.text }}</v-list-item-title>
              <v-list-item-subtitle
                ><v-text-field
                  placeholder="Value"
                  v-model="
                    editProduct.attributes[
                      editProduct.attributes.findIndex(
                        (attr) => attr.key === field.key
                      )
                    ].value
                  "
                  outlined
                  label=""
                  dense
              /></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-for="(field, index) in newFields" :key="index">
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field
                  placeholder="New field"
                  v-model="newFields[index].text"
                  outlined
                  dense
                />
              </v-list-item-title>
              <v-list-item-subtitle
                ><v-text-field
                  placeholder="Field value"
                  v-model="newFields[index].value"
                  outlined
                  label=""
                  dense
              /></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon @click="removeField(index)" color="error"
                >remove_circle</v-icon
              >
            </v-list-item-action>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                ><images-container
                  :editable="true"
                  :images="product.assets.images || []"
                  :files.sync="additionalImages"
              /></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
        <v-card-actions>
          <v-flex>
            <v-btn @click="addField" color="primary"
              >Add Field<v-icon right>add</v-icon></v-btn
            >
          </v-flex>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn @click="save" color="primary">Save</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import request from "@/modules/request";
import ActionModal from "./ActionModal";
import ImagesContainer from "@/components/shared/ImagesContainer";
import shortid from "shortid";
import uniqid from "uniqid";

export default {
  name: "EditProductModal",
  props: {
    product: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  components: {
    ActionModal,
    // ImagesContainer,
  },
  async created() {
    await this.loadData();
  },
  data() {
    return {
      categories: [],
      category: {},
      subcategories: [],
      additionalImages: [],
      newFields: [],
    };
  },
  computed: {
    editProduct: {
      get: function() {
        return this.product;
      },
      set: function() {},
    },
    validProduct() {
      const {
        productCode,
        manufacturer,
        name,
        category,
        description,
        invoicePrice,
      } = this.editProduct;
      return (
        productCode &&
        manufacturer &&
        name &&
        category &&
        description &&
        invoicePrice
      );
    },
  },
  methods: {
    updateSubcategorySelection() {
      const { categories, editProduct } = this;
      this.category = categories.find((cat) => {
        return cat._id === editProduct.category._id;
      });
      this.editProduct.subcategory = null;
      this.subcategories = this.category.subcategories;
    },
    async uploadImages() {
      const uploadPromises = this.additionalImages.map(async (file) => {
        const uniqueFileName = `${shortid.generate()}_${file.name}`;
        const { data: presignedUrl } = await this.getPresignedUrl(
          uniqueFileName,
          file.type
        );
        this.editProduct.assets.images.push({
          key: uniqueFileName,
        });
        return request
          .callExternal({
            method: "PUT",
            url: presignedUrl,
            headers: {
              "Content-Type": file.type,
            },
            data: file,
          })
          .then((results) => {
            return results;
          })
          .catch((error) => {
            console.error("error uploading image", error);
          });
      });

      await Promise.all(uploadPromises).catch((error) => {
        console.log("upload proms error", error);
      });
    },
    async getPresignedUrl(fileName, fileType) {
      return await request.callInternal({
        method: "get",
        route: `/api/admin/presignedurl/?fileName=${fileName}&fileType=${fileType}`,
      });
    },
    async save() {
      const { editProduct, additionalImages, newFields } = this;
      // upload files first
      if (additionalImages.length) {
        await this.uploadImages();
      }
      this.$emit("save", { product: editProduct, newFields });
    },
    close() {
      this.$emit("update:editProductModal", false);
    },
    async loadData() {
      const { getCategories } = this;
      await Promise.all([getCategories()]).then((results) => {
        const [categories] = results;
        this.categories = categories;
        this.setCategory();
        this.handleEmptyAttributes();
      });
    },
    setCategory() {
      const { categories, editProduct } = this;
      this.category = categories.find((cat) => {
        return cat._id === editProduct.category._id;
      });
      this.subcategories = this.category.subcategories;
    },
    getCategories() {
      const opts = {
        method: "get",
      };
      return request
        .callInternal({
          method: "get",
          route: "/api/admin/fullcategories",
        })
        .then((results) => {
          return results.data;
        });
    },
    handleEmptyAttributes() {
      const { editProduct, category } = this;
      category.fieldSettings.forEach((field, index) => {
        if (
          editProduct.attributes.findIndex((attr) => attr.key === field.key) ===
          -1
        ) {
          editProduct.attributes.push({
            value: "",
            key: field.key,
            text: field.text,
          });
        }
      });
    },
    addField() {
      this.newFields.push({
        text: "",
        value: "",
        key: uniqid(),
      });
    },
    removeField(index) {
      this.newFields.splice(index, 1);
    },
  },
};
</script>
